// An amount in its currency, in the reader's locale: "SRD 14,500.00",
// "$14,500.00" (en-US); "SRD 14.500,00", "US$ 14.500,00" (nl-NL). The same
// Intl formatting as the amounts on Payroll and Finance.
export const formatCurrency = (amount, currency = 'SRD', locale) => new Intl.NumberFormat(locale, {
  style: 'currency',
  currency,
}).format(Number(amount) || 0);
